import { leaveListMiddleware as getLeaveListMiddleware } from './leave-list-middleware';
import { leaveHistoryListMiddleware } from './leave-history-middleware';
import { leaveSummaryMiddleware } from './leave-summary-middleware';
export const leaveMiddleware = [
  getLeaveListMiddleware,
  leaveSummaryMiddleware,
  leaveHistoryListMiddleware,
];
